<template>
  <div class="main-container security ">
    <div class="hidden-sm-and-down">
       <div class="secrtop">
          <img src="../assets/lylogo.png" alt="" />
          <p>匠心品质 <span></span>为美而生</p>
        </div>
    <div class="securbot">
      <div class="content">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-dark title">
              一、微信扫码关注“刘燕酿制官方”
            </div>
          </el-col>
        </el-row>
        <el-row class="bag">
          <el-col :xs="24" :sm="12" :md="12">
            <div class="grid-content bg-purple">
              <img style="background-image: radial-gradient(#fff 88%, #000 0);padding: .02rem;" src="../../static/lyewm.jpg" alt="" />
              <h3 class="boxtitle">公众号：“刘燕酿制官方”</h3>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <div class="grid-content bg-purple-light">
              <img style="width:60%" src="../../static/lysys.png" alt="" />
            </div>
          </el-col>
        </el-row>
      </div>
          <div class="content box">
            <el-row>
                <el-col :span="24">
                    <div class="grid-content bg-purple-dark">二、点击下方菜单栏【 防伪查询 】，即可查询真伪!</div>
                </el-col>
            </el-row>
            <el-row class="bag">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="grid-content bg-purple-light">
                        <img src="../../static/lyfwcx.png" alt="">
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="grid-content bg-purple-light rimg">
                        <img src="../../static/tips.png" alt="">
                    </div>
                </el-col>
            </el-row>
        </div>
             <div class="content box">
            <el-row>
                <el-col :span="24">
                    <div class="grid-content bg-purple-dark">三、在【 防伪查询 】页面扫码或输入防伪验证码查询真伪，即可显示查询结果。</div>
                </el-col>
            </el-row>
            <el-row class="bag">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="grid-content bg-purple-light sm">
                        <img style="width:80%" src="../../static/sm.png" alt="">
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="grid-content bg-purple-light sm">
                        <img style="width:80%" src="../../static/sm2.png" alt="">
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
    </div>

    <div class="hidden-md-and-up mob">
         <div class="mobsecrtop">
          <p>匠心品质<span></span>为美而生</p>
        </div>
        <div class="mobsecurbot">
           <div style="text-align: center;">
              <div class="title">
                一、微信扫码关注刘燕酿制官方
              </div>
              <img style="width:2.15rem;background-image: radial-gradient(#fff 88%, #000 0);padding: .02rem;" src="../../static/lyewm.jpg" alt="" />
              <h3 class="boxtitle">刘燕酿制官方</h3>
              <img style="width:3.98rem" src="../../static/lysys.png" alt="" />
           </div>
        </div>
          <div class="mobsecurbot">
           <div style="text-align: center;">
             <div class="title">
               二、点击下方菜单栏【防伪查询】，进入查询界面！
              </div>
              <img style="width:3.98rem" src="../../static/lyfwcx.png" alt="" />
              <img style="width:5.89rem;margin-bottom:1rem" src="../../static/tips.png" alt="" />
           </div>
        </div>
            <div class="mobsecurbot">
           <div style="text-align: center;">
             <div class="title" style="height:1rem;font-size:0.24rem;line-height:0.4rem;padding-top:0.2rem">
                三、在【 防伪查询 】页面扫码或输入防伪验证码查询真伪，即可显示查询结果。
              </div>
              <img style="width:5.98rem" src="../../static/sm.png" alt="" />
              <img style="width:5.89rem" src="../../static/sm2.png" alt="" />
           </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewLiuyanShopWebSecurity",

  components: {},

  directives: {},

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.security {
  width: 100%;
  .secrtop {
    background: url(../../static/fwtop.jpg) no-repeat center center/100% 100%;
    width: 100%;
    padding: 4% 0 3% 0;
    img {
      width: 100%;
      max-width: 113px;
      // margin-top: 4%;
    }
    p {
      font-size: 28px;
      margin-top: 3%;
      span {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #00383f;
        border-radius: 50%;
        margin: 0 13px;
      }
    }
  }
  @media (min-width:1920px) {
    .securbot {
      background: url(../../static/fwbot_01.jpg) no-repeat center top/100%,
                  url(../../static/fwbot_02.jpg) no-repeat center 641px/100% calc(100% - 1390px),
                  url(../../static/fwbot_03.jpg) no-repeat center bottom/100%!important;
    }
  }
  .securbot {
    background: url(../../static/fwbot_01.jpg) no-repeat center top/100%,
                url(../../static/fwbot_02.jpg) no-repeat center 33.38vw/100% calc(100% - 72.4vw),
                url(../../static/fwbot_03.jpg) no-repeat center bottom/100%;
     min-height:calc(100vh - 600px);
    width: 100%;
    .bg-purple-dark {
      background: #00383f;
    }

    .grid-content {
      color: #fff;
      font-size: 24px;
      padding-left: 20px;
      padding-bottom: 1%;
      padding-top: 1%;
      line-height: 24px;
      border-radius: 4px;
      min-height: 36px;
      line-height: 36px;
      text-align: left;
    }

    .boxtitle {
      color: #000;
      font-size: 12px;
    }

    .bg-purple,
    .bg-purple-light {
      text-align: center;
    }

    .bg-purple-light p {
      color: #000;
      font-size: 12px;
    }

    .bg-purple img {
      width: 30%;
      margin-top: 23%;
    }

    .bg-purple-light img {
      width: 51%;
      margin: 6% auto;
    }

    .rimg img {
      margin: 20% auto;
    }

    .title {
      margin-top: 50px;
    }

    .box {
      padding-bottom: 50px !important;
    }

    .bag {
      line-height: 10;
    }

    .row-bg {
      padding: 10px 0;
      background-color: #f9fafc;
    }

    .content {
      max-width: 60%;
      margin: 0 auto;
    }
  }
}
@media (max-width: 991px) {
  .mobsecrtop{
    width: 100%;
    height: 1.18rem;
    background: url(../../static/fwtop.jpg) no-repeat center center/100% 100%;
    color: #00383F;

    p{
      font-size: 0.3rem;
      font-weight: 900;
      line-height: 1.18rem;
      text-align: center;
      span{
        width: 0.08rem;
        height: 0.08rem;
        background: #00383F;
        border-radius: 50%;
        display: inline-block;
        margin: 0 0.13rem;
        vertical-align: middle;
      }
    }
  }
  .mob{
        background: url(../../static/mobile/productbg.png) no-repeat;
        background-size: 100% 100%;
        text-align: left;
     .mobsecurbot{

    .title{
      background: #00383F;
      margin: 0 0.4rem;
      height: 0.597rem;
      color: #fff;
      font-size: 0.26rem;
      line-height: 0.597rem;
      padding-left: 0.2rem;
      margin-bottom: 0.6rem;
      text-align: left;
    }
    h3{
      font-size: 0.24rem;
      font-weight: 900;
      margin: 0.3rem 0 0.62rem 0;
    }
  }
  }

}
</style>



// WEBPACK FOOTER //
// src/view/Security.vue